// Constants for the cross-frame message protocol. Private (MessageChannel)
// and public (broadcast) versions evolve independently — see the
// project_cross_frame_modals memory and project_postmessage_object_payloads
// memory for the full design.

// Handshake message types used to establish a MessageChannel between an
// iframe (client) and its hosting page (host). The host can be our embed
// script on a partner page, the FLP, or any of our own pages that load
// our iframes.
export const CONNECT     = 'connect'
export const CONNECT_ACK = 'connectAck'

// Current version of the private (MessageChannel) protocol. Bumped only
// for breaking changes; additive changes don't bump. Both host and client
// declare the versions they support and negotiate to the highest mutual.
export const PRIVATE_PROTOCOL_VERSION = 1

// Current version of the FSA envelope used by admin/IH internal
// notifications via sendBroadcast. We own both sides of this wire,
// so the version is stable at 1 and only bumps on breaking changes.
export const INTERNAL_PROTOCOL_VERSION = 1

// Current version of the partner-facing FSA envelope emitted by
// sendPublic. Marked `'1beta'` while we use it internally to stress
// test it before publishing v1 docs — partners that reverse-engineer
// the wire and depend on it during this window have been told (via
// `meta.notice`) that the shape is not stable. Promote to `1` and
// drop the notice when we ship the docs.
export const PUBLIC_PROTOCOL_VERSION = '1beta'

// Identifier in `meta.source` for every message we emit. Lets receivers
// filter out unrelated cross-frame postMessages from analytics tags,
// browser extensions, or other vendor scripts that might be living in
// the same window.
export const SOURCE = 'pledge'

// Default handshake timeout. After this, a client gives up waiting for
// the host (most likely cause: parent hasn't loaded our embed script,
// or whatever runs the channel host on its side). The client's
// failed-handshake path is where the "widget is embedded incorrectly"
// console warning belongs, replacing what intersectingIframe.js used
// to do before this protocol existed.
export const DEFAULT_HANDSHAKE_TIMEOUT_MS = 1000
